import SurveyAnswerCard from "./surveyAnswerCard.container";
export default SurveyAnswerCard;